import { render, staticRenderFns } from "./Saldo.vue?vue&type=template&id=6d978f86&scoped=true"
import script from "./Saldo.vue?vue&type=script&lang=js"
export * from "./Saldo.vue?vue&type=script&lang=js"
import style0 from "./Saldo.vue?vue&type=style&index=0&id=6d978f86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d978f86",
  null
  
)

export default component.exports